/* PACKAGES */
import React from 'react';

/* STYLES */
import s from './Slider.module.scss';

const SliderArrows = ({ totalUniqueSlides, infinite, index, goToSlide, label = 'slide' }) => {
	const handleArrowClick = (e) => {
		e.preventDefault();
		const direction = e.currentTarget.value;
		goToSlide(index + parseInt(direction, 10), e);
	};

	return (
		<div className={s.slider_arrows}>
			<button type="button" className={[s.slider_arrow, s.slider_arrow__left, (index === 0 + infinite && infinite === 0 ? s.slider_arrow__first : null)].join(' ')} value="-1" onClick={handleArrowClick} aria-label={`Previous ${label}`}>
				<span />
			</button>
			<button type="button" className={[s.slider_arrow, s.slider_arrow__right, (totalUniqueSlides === index - infinite && infinite === 0 ? s.slider_arrow__last : null)].join(' ')} value="1" onClick={handleArrowClick} aria-label={`Next ${label}`}>
				<span />
			</button>
		</div>
	);
};

export default SliderArrows;
